import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Heading, Modal, ModalControlModalProps, Text } from '@frontend/design-system';

interface ServiceProviderMappingAlertModalProps {
  modalProps: ModalControlModalProps;
}

export const ServiceProviderMappingAlertModal = ({ modalProps }: ServiceProviderMappingAlertModalProps) => {
  const { t } = useTranslation('schedule');
  return (
    <Modal {...modalProps}>
      <Modal.Header>
        <div css={{ display: 'flex', alignItems: 'center' }}>
          <Heading level={2}>{t('Provider Mapping Error')}</Heading>
          <Icon name='alert-invert' css={{ marginLeft: theme.spacing(1) }} color='error' />
        </div>
      </Modal.Header>
      <Modal.Body>
        <Text css={{ marginTop: theme.spacing(2) }}>
          {t(
            "Oops! It seems this provider isn't mapped to a Parent Office provider. No worries, you can easily fix this by selecting a Parent Office provider from the Parent Office Provider list in the edit provider screen."
          )}
        </Text>
        <Text weight='bold' css={{ marginTop: theme.spacing(2) }}>
          {'Note: For successful writeback of appointments, the provider must be mapped to a Parent Office provider.'}
        </Text>
      </Modal.Body>
      <Modal.Actions primaryLabel={t('Done')} onPrimaryClick={modalProps.onClose} />
    </Modal>
  );
};
